import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { saveAs } from 'file-saver'
import { toast } from 'react-toastify'

const useSave = (imageUrl: string | undefined) => {
  const { t } = useTranslation()

  const [isSaved, setIsSaved] = useState(false)

  const handleSave = useCallback(() => {
    if (imageUrl == null) return

    try {
      saveAs(imageUrl, 'image.jpg')
      setIsSaved(true)
      setTimeout(() => setIsSaved(false), 3000)
    } catch (e) {
      toast.error(t('error.download'))
    }
  }, [t, imageUrl])

  return { isSaved, handleSave }
}

export default useSave
